import {
  STRENGTH_SCALE_MAX,
  STRENGTH_SCALE_MIN_FILLED,
  NICOTINE_TO_TAR_SCALE_FACTOR,
} from './strengthScale.const'

const clampFilled = value =>
  Math.min(STRENGTH_SCALE_MAX, Math.max(STRENGTH_SCALE_MIN_FILLED, Math.round(value)))

const toScalePoint = (value, toFilled) => {
  if (value === null || value === undefined) return null
  return { value, filled: clampFilled(toFilled(value)) }
}

/**
 * Строит данные для шкалы крепости (смола/никотин) из crmProduct.
 * @param {{tarValue?: number, nicotineValue?: number}} crmProduct
 * @returns {{tar: {value: number, filled: number} | null, nicotine: {value: number, filled: number} | null}}
 */
export const getStrengthScale = (crmProduct = {}) => {
  const { tarValue, nicotineValue } = crmProduct
  return {
    tar: toScalePoint(tarValue, value => value),
    nicotine: toScalePoint(nicotineValue, value => value * NICOTINE_TO_TAR_SCALE_FACTOR),
  }
}
